import React from "react";
import _ from "lodash";
import { Form, Button, Message, Table, Dropdown } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import api from "../../api";
import settings from "../../settings";

class GlbRegisterForm extends React.Component {
  state = {
    glbs: [],
    glbWording: "",
    options: [],
    loading: false,
    errors: {},
  };

  componentDidMount() {
    let mastType = "";
    if (this.props.userInfo && this.props.userInfo.MastType) {
      mastType = this.props.userInfo.MastType;
    }
    let mastState = "";
    if (this.props.userInfo && this.props.userInfo.MastState) {
      mastState = this.props.userInfo.MastState;
    }
    api.user
      .getDisclosures(this.props.userCode, mastType, mastState, true)
      .then((res) => {
        const options = [];
        const glbs = [];
        options.push({ key: "", value: 0, text: "Please select GLB" });
        _.map(res.data.Data, (state) => {
          const discValue = parseInt(state.Id, 10);
          options.push({
            key: state.DiscDesc,
            value: discValue,
            text: state.DiscDesc,
          });
          glbs.push({
            Id: state.DiscId,
            DiscId: state.DiscId,
            DiscDesc: state.DiscDesc,
            DiscValue: discValue,
            DiscWording: state.DiscWording,
          });
        });
        this.setState({ glbs, options, cancelTokenSource: undefined });
      })
      .catch((err) => {
        console.log("Glb disclosures error - ", err, " - ", err.response);
        this.setState({ cancelTokenSource: undefined });
      });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.selectedGlb);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props
        .submit(this.state.selectedGlb.value)
        .then(() => this.setState({ loading: false }))
        .catch(() => this.setState({ loading: false }));
    }
  };

  getApplicationName = () => {
    switch (settings.appName.toLocaleLowerCase()) {
      case "entersect":
        return "Entersect";
      case "lppolice":
        return "LP Police";
      default:
        return "LocatePlus";
    }
  };

  handleGlbSelect = (e, data) => {
    let glbWording = "";
    if (data.value > 0) {
      const currentGlb = _.find(this.state.glbs, (g) => g.Id === data.value);
      if (currentGlb) {
        glbWording = currentGlb.DiscWording;
      }
    }
    this.setState({
      selectedGlb: { name: data.name, value: data.value },
      glbWording,
      errors: { glb: "" },
    });
  };

  validate = (data) => {
    const errors = {};
    if (!data.name || data.name === "" || data.value === 0)
      errors.glb = "Please select a GLB";
    return errors;
  };

  render() {
    const { errors, loading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {errors.global && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global}</p>
          </Message>
        )}
        <Table className={"border-none"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell width={9}>
                <div>
                  All customers must verify the appropriate level of GLB
                  compliance in order to access our information.
                  <br />
                  <br />
                </div>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={9}>
                I, <b>{this.props.userInfo && this.props.userInfo.FirstName}</b>{" "}
                hereby certify that I am conducting business in the state of{" "}
                <b>{this.props.userInfo && this.props.userInfo.MastState}</b>{" "}
                and accessing {this.getApplicationName()} information for the
                primary purpose selected below. <br />
                <br />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={9}>
                <Form.Field error={!!errors.glb}>
                  <Dropdown
                    fluid
                    search
                    selectOnBlur={false}
                    selection
                    id={"dd_glb"}
                    options={this.state.options}
                    name={"dd_glb"}
                    value={
                      this.state.selectedGlb && this.state.selectedGlb.value
                    }
                    onChange={this.handleGlbSelect}
                  />
                  {errors.glb && <InlineError text={errors.glb} />}
                  {this.props.glbSetupError && (
                    <InlineError text={this.props.glbSetupError} />
                  )}

                  {this.state.glbWording !== "" && (
                    <span>
                      <b>Currently selected GLB purpose is: </b>{" "}
                      {this.state.glbWording}
                    </span>
                  )}
                </Form.Field>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={9}>
                <div>
                  <br />
                  You may contact our customer service to change your selection
                  at any time after your initial selection.
                  <br />
                  &nbsp;
                </div>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={9}>
                <Button primary>Set GLB</Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Form>
    );
  }
}

export default GlbRegisterForm;



// WEBPACK FOOTER //
// ./src/components/forms/GlbRegisterForm.js